export const SET_ALL_FILES = 'SET_ALL_FILES';
export const SET_PROJECT_FILES = 'SET_PROJECT_FILES';
export const SET_ORIGINAL_FILENAME = 'SET_ORIGINAL_FILENAME';
export const SET_FILE_PROJECT_ID = 'SET_FILE_PROJECT_ID';
export const SET_UPLOAD_FILE = 'SET_UPLOAD_FILE';
export const SET_IS_LOADING = 'SET_IS_LOADING';



// WEBPACK FOOTER //
// ./src/infrastructure/fileuploads/store/_types.js